package com.parmartechnologies.storage.table.chat.conversation

import com.parmartechnologies.core.feature.chat.conversation.model.Conversation
import com.parmartechnologies.storage.collection.DatabaseCollection
import com.parmartechnologies.storage.table.DatabaseTable
import kotlinx.coroutines.launch

class ConversationDatabaseTable : DatabaseTable() {
    fun insert(item: Conversation) {
        DatabaseCollection().insert(item, Conversation.serializer())
    }

    fun insert(items: List<Conversation>?) {
        scope.launch {
            items?.forEach { item ->
                insert(item)
            }
        }
    }

    fun retrieve(id: String, callback: (List<Conversation>) -> Unit) {
//        val andQuery : Map<String,Any> = mapOf(Pair("product_id",id))
        DatabaseCollection().findAllByUserId(id, Conversation.serializer()){
            callback(it)
        }
    }

    fun retrieveForBusiness(id: String, callback: (List<Conversation>) -> Unit) {
        DatabaseCollection().findAllByBusinessId(id, Conversation.serializer()){
            callback(it)
        }
    }
}